import { nullableSchema, objectSchema, schemaProperties } from "vue-utils"

export const extend = schemaProperties

export type Id = number
export const Id = Number

export type Nullable<T> = T | null
export const Nullable = nullableSchema

export interface Identifiable {
	Id: Id
}
export const Identifiable = objectSchema<Identifiable>({
	Id
})

export interface Named {
	Name: string
}
export const Named = objectSchema<Named>({
	Name: String
})
